module.exports = __webpack_public_path__ + "static/media/HeroCooking.b3333daa.jpg";